<script setup>
import { computed } from 'vue';
import { Radar } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend,
  RadialLinearScale, PointElement, LineElement, Filler
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

const props = defineProps({
  itemLabels: { 
    type: Array,
    required: true
  },
  ourClassPercentages: { 
    type: Array,
    default: () => []
  },
  chartHeight: { 
    type: String,
    default: '280px' 
  }
});

const chartData = computed(() => {
  const ourClassColor = '#E469A7';  

  return {
    labels: props.itemLabels, 
    datasets: [
      {       
        data: props.ourClassPercentages,     
        backgroundColor: 'rgba(228, 105, 167, 0.1)',
        borderColor: ourClassColor, 
        borderWidth: 2,
        pointBackgroundColor: ourClassColor, 
        pointBorderColor: ourClassColor,    
        pointRadius: 3,   
        fill: true, 
      }
    ],
  };
});

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false, 
  layout: {
    padding: { left: 10, right: 10, top: 0, bottom: 0 }
  },
  scales: {
    r: {
      angleLines: { color: '#ccc', display: true },
      grid: {
        color: '#ccc',
        display: true,
        lineWidth: 2,     
      },
      pointLabels: { display: false },
      min: -25,
      max: 100,
      ticks: { 
        display: false,
        stepSize: 25, 
      },      
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: { display: false, enabled: false}
  },
}));
</script>

<template>    
  <div :style="{height: chartHeight, width:chartHeight}" class="chart">
      <ul>
        <li>100%</li>
        <li>75%</li>
        <li>50%</li>
        <li>25%</li>
        <li>0%</li>
      </ul>
      <Radar :data="chartData" :options="chartOptions"></Radar>
  </div>    
</template>

<style lang="scss" scoped>
.chart {
  position: relative;
  z-index: 1;
  ul {
    position: absolute;
    right: -45px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.5;
    font-size: 1rem;
    color: #ABAEB9;
    text-align: right;
    z-index: -1;
    li {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: -140px;
        bottom: 50%;
        transform: translateY(-50%);
        width: 130px;
        border-top: 2px dashed #E9E9E9;       
      }
    }
  }
  &::after {
    content: "";   
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: #E469A71A;
  }
}
</style>